import Translate from "../../utils/Translate";
import { Grid, Button, Dialog } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import PersonIcon from "@mui/icons-material/Person";
import DomainIcon from "@mui/icons-material/Domain";
import ConstructionIcon from "@mui/icons-material/Construction";
import EmailIcon from "@mui/icons-material/Email";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import BadgeIcon from "@mui/icons-material/Badge";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import BuildIcon from "@mui/icons-material/Build";
import Api, { useApi } from "../../utils/Api";
import download from "downloadjs";
import { AccountBox, CheckCircle, HowToReg, PictureAsPdf, Visibility } from "@mui/icons-material";
import { permitStatusToSortableValue, renderPermitStatus } from "../actor-permits/utils/permitStatus";
import { accessKeys, hasAccess } from "../../utils/userAccess";
import { addPermitToAppleWallet, addPermitToGoogleWallet } from "./digitalPermitHelper";
import { useSnackbar } from "notistack";
import { getAppleWalletImgSrc, getGoogleWalletImgSrc } from "./digitalLicenseHelper";
import PermitDetailsDialog from "../actor-permits/responsible-view/PermitDetailsDialog";

export default function DigitalPermitView({ permit, onClick }) {
  const [loading, setLoading] = useState(false);
  const [showPermitDetails, setShowPermitDetails] = useState(false);

  const navigate = useNavigate();
  const api = useApi();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  async function handleDownloadActorPermit(actorPermitId, actorName, dataId) {
    setLoading(actorPermitId);
    const blob = await Api.fetchBlob(
      `${import.meta.env.VITE_MAIN_URL}permits/pdf/digital?actorPermitId=${actorPermitId}&dataId=${dataId}`,
      false,
      "GET",
    );
    const filename = `permit-${actorName.trim().replace(" ", "_")}-${actorPermitId}.pdf`;
    download(blob, filename, blob.type);
    setLoading(false);
  }

  return (
    <>
      {showPermitDetails && (
        <Dialog
          open
          onClose={() => setShowPermitDetails(false)}
          className="bigCourseDialog"
          maxWidth={false}
          scroll="paper"
        >
          <PermitDetailsDialog
            actorPermitId={showPermitDetails.actorPermitId}
            dataId={showPermitDetails.dataId}
            onClose={() => setShowPermitDetails(false)}
          />
        </Dialog>
      )}
      <div className="dlCard" style={{ cursor: "default" }} /* onClick={onClick} */>
        <div className="dlCardIcon" style={{ maxWidth: "730px" }}>
          <div>
            <div>
              <PersonIcon />
            </div>
            <div>{permit.actorName}</div>
          </div>
          <div>
            <div>
              <EmailIcon />
            </div>
            <div>{permit.actorEmail}</div>
          </div>
          <div>
            <div>
              <DomainIcon />
            </div>
            <div>{permit.parentActorName}</div>
          </div>
          <div>
            <div>
              <HowToReg />
            </div>
            <div>
              {!!permit.responsibleActorName && !!permit.responsibleTitle
                ? `${permit.responsibleActorName} / ${permit.responsibleTitle}`
                : (permit.responsibleActorName ?? permit.responsibleTitle)}
            </div>
          </div>
          <div>
            <div>
              <EmailIcon />
            </div>
            <div>{permit.responsibleActorEmail}</div>
          </div>
          <div>
            <div>
              <ConstructionIcon />
            </div>
            <div>{permit.skillGroupDescription}</div>
          </div>
          <div>
            <div>
              <BuildIcon />
            </div>
            <div>{permit.skills.map((s) => `${s.shortCode} ${s.description}`).join(", ")}</div>
          </div>
          <div>
            <div>
              <CheckCircle />
            </div>
            <div>{renderPermitStatus(permitStatusToSortableValue(permit), permit)}</div>
          </div>

          {/*  <div>{permit.parentActorName}</div>
        <div>
          {permit.responsibleActorName}, {permit.responsibleActorEmail}
        </div>
        <div>{permit.skillGroupDescription}</div>
        <div>
          {permit.skills
            .map((s) => `${s.shortCode} ${s.description}`)
            .join(", ")}
        </div> */}
        </div>
        <div className="dlCardButtonBox">
          <div>
            <Tooltip title={Translate.get("Show")}>
              <Button
                className="regularButtonWithIcon stdLightLoader"
                variant="contained"
                //tooltip={Translate.get('Download')}
                onClick={(event) => {
                  event.stopPropagation();
                  setShowPermitDetails(permit);
                }}
              >
                <Visibility />
              </Button>
            </Tooltip>
          </div>
          <div>
            <Tooltip title={Translate.get("Download")}>
              <Button
                className="regularButtonWithIcon stdLightLoader"
                variant="contained"
                //tooltip={Translate.get('Download')}
                loading={permit.actorPermitId === loading}
                onClick={(event) => {
                  event.stopPropagation();

                  handleDownloadActorPermit(permit.actorPermitId, permit.actorName, permit.dataId);
                }}
              >
                <PictureAsPdf />
              </Button>
            </Tooltip>
          </div>
          {hasAccess(accessKeys.digitalLicensesHolder) && (
            <>
              <div>
                <Button
                  variant="text"
                  className={
                    "walletButton" +
                    (!permit.signatureId || !permit.responsibleSignatureId ? " disabledWalletButton" : "")
                  }
                  onClick={async () =>
                    await addPermitToAppleWallet(permit.actorPermitId, permit.dataId, enqueueSnackbar, closeSnackbar)
                  }
                  disabled={!permit.signatureId || !permit.responsibleSignatureId}
                >
                  <img src={getAppleWalletImgSrc()} />
                </Button>
              </div>
              <div>
                <Button
                  variant="text"
                  className={
                    "walletButton" +
                    (!permit.signatureId || !permit.responsibleSignatureId ? " disabledWalletButton" : "")
                  }
                  onClick={async () => await addPermitToGoogleWallet(api, permit.actorPermitId, permit.dataId)}
                  disabled={!permit.signatureId || !permit.responsibleSignatureId}
                >
                  <img src={getGoogleWalletImgSrc()} />
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
